﻿﻿import { ClusterDateField } from '../enums/index';

export interface IUpdateClusterDate {
    clusterId: number;
    whichDate: ClusterDateField;
    dateTimeValue: string;
}
